export default __webpack_public_path__ + "static/media/rakhi11.c2cb22e9.jpeg";